const isEven = (n: number): boolean => (n & 1) === 0;

export default isEven;
